export default __webpack_public_path__ + "static/media/img9.e8211d7a.PNG";